Oskari.clazz.define('Oskari.mapframework.domain.MaplayerGroup', function () {
  var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var me = this;
  me.groups = [];
  if (Array.isArray(json.groups)) {
    json.groups.forEach(function (subgroup) {
      me.groups.push(Oskari.clazz.create('Oskari.mapframework.domain.MaplayerGroup', subgroup));
    });
  }
  me.id = json.id;
  me.layersModels = [];
  me.layers = json.layers || [];
  me.name = json.name;
  me.description = json.desc;
  me.locale = json.locale;
  me.orderNumber = typeof json.orderNumber !== 'undefined' ? json.orderNumber : 1000000;
  me.parentId = typeof json.parentId !== 'undefined' ? json.parentId : -1;
  me.selectable = typeof json.selectable === 'boolean' ? json.selectable : true;
  me.toolsVisible = typeof json.toolsVisible === 'boolean' ? json.toolsVisible : true;
  me.children = [];
  me.setChildren(json);
}, {
  getGroups: function getGroups() {
    return this.groups || [];
  },
  setGroups: function setGroups(groups) {
    this.groups = groups;
  },
  getId: function getId() {
    return this.id;
  },
  setId: function setId(id) {
    this.id = id;
  },
  addChildren: function addChildren(children) {
    this.children.push(children);
  },
  removeChild: function removeChild(type, id) {
    var filteredChildren = this.children.filter(function (c) {
      return !(c.type === type && c.id === id);
    });
    this.children = filteredChildren;
  },
  setChildren: function setChildren(json) {
    var me = this;
    me.children = [];
    if (json.layers) {
      json.layers.forEach(function (l) {
        me.children.push({
          id: l.id,
          type: 'layer',
          order: l.orderNumber
        });
      });
    }
    me.groups.forEach(function (g) {
      me.children.push({
        id: g.getId(),
        type: 'group',
        order: g.getOrderNumber()
      });
    });
    me.sort();
  },
  sort: function sort() {
    this.children.sort(function compare(a, b) {
      // if layer and group have same order then layer go upper
      if (a.type === 'layer' && b.type === 'group' && a.order === b.order) {
        return -1;
      }
      if (a.type === 'group' && b.type === 'layer' && a.order === b.order) {
        return 1;
      }

      // else use order or id to sort
      if (a.order < b.order) {
        return -1;
      }
      if (a.order > b.order) {
        return 1;
      }
      if (a.id < b.id) {
        return -1;
      }
      if (a.id > b.id) {
        return 1;
      }
      return 0;
    });
  },
  getChildren: function getChildren() {
    return this.children;
  },
  getLayerIdList: function getLayerIdList() {
    return this.getChildren().filter(function (c) {
      return c.type === 'layer';
    }).map(function (c) {
      return c.id;
    });
  },
  getName: function getName() {
    return this.name;
  },
  setName: function setName(name) {
    this.name = name;
  },
  getDescription: function getDescription() {
    return this.description;
  },
  setDescription: function setDescription(description) {
    this.description = description;
  },
  getLocale: function getLocale() {
    return this.locale;
  },
  setLocale: function setLocale(locale) {
    this.locale = locale;
  },
  /**
   * You probably shouldn't be using this but getChildren().filter(c => c.type === 'layer')
   * @returns probably not the thing you were looking for...
   */
  getLayers: function getLayers() {
    return this.layers;
  },
  setLayers: function setLayers(layers) {
    this.layers = layers;
  },
  getOrderNumber: function getOrderNumber() {
    return this.orderNumber;
  },
  setOrderNumber: function setOrderNumber(orderNumber) {
    this.orderNumber = orderNumber;
  },
  getParentId: function getParentId() {
    return this.parentId;
  },
  setParentId: function setParentId(parentId) {
    this.parentId = parentId;
  },
  hasSelectable: function hasSelectable() {
    return this.selectable;
  },
  setSelectable: function setSelectable(selectable) {
    this.selectable = selectable;
  },
  hasLayers: function hasLayers() {
    return this.getChildren().filter(function (children) {
      return children.type === 'layer';
    }).length > 0;
  },
  hasSubgroups: function hasSubgroups() {
    return this.groups.length > 0;
  },
  hasToolsVisible: function hasToolsVisible() {
    return this.toolsVisible;
  },
  setToolsVisible: function setToolsVisible(toolsVisible) {
    this.toolsVisible = toolsVisible;
  }
});